import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from 'gatsby';

export const mapStateToProps = state => {
  return {
    authToken: state.auth.token
  };
};

export class Redirect extends Component {
  componentDidMount() {
    if (!this.props.authToken) {
      navigate('/select-number/');
    }
  }

  render() {
    return null;
  }
}

const ConnectedRedirect = connect(mapStateToProps)(Redirect);

const withRedirect = WrappedComponent => {
  class ComponentWithRedirect extends Component {
    render() {
      return (
        <Fragment>
          <ConnectedRedirect />
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  }

  return ComponentWithRedirect;
};

export default withRedirect;
